import { Form } from 'factorial-form'

class CompanyGeneral extends Form {
  constructor(values: object) {
    super(values, {
      locale: 'string',
      slug: 'string',
      public_email: 'string',
      name: 'string',
      country_factorial_domain: 'string',
      industry: 'string',
    })
  }
}

export default CompanyGeneral
